import { LabelHTMLAttributes } from "react";
import styles from "./Label.module.scss";

interface LabelProps extends LabelHTMLAttributes<HTMLLabelElement> {
  children: React.ReactNode;
  required?: boolean;
}

export default function Label({ children, required, className, ...props }: LabelProps) {
  return (
    <label className={`${styles.label} ${className ?? ""}`} {...props}>
      {children}
      {required && <span className={styles.required}>*</span>}
    </label>
  );
}
